import React from 'react';
import IsConnected from '../../IsConnected/IsConnected'
import EditColleague from './EditColleague'

class ParselEditColleague extends React.Component {

 render() {
   const {...props} = this.props
   return (
     <IsConnected Component={EditColleague} {...props}/>
   )
 }
}



export default ParselEditColleague;
